import { AsyncLoadingSection, Render, buildEndpoint, defaultDataTransform, useDataFetcher, useIdParam } from '@techsharegov/react-ui';
import { Routes } from 'Navigation';
import React from 'react';
import { CommitteeProvider } from './CommitteeProvider';
import { AdminSubHeaderMainLayout } from 'Components/Display';
import { AgendaEndpoints } from 'Models/Routes';

export class CommitteeBasicInfoModel {
  name?: string;
  allowPublicApplications?: boolean
}

export const ViewCommittee: React.FC = () => {
  const [id] = useIdParam();

  const [data, loadingStatus] = useDataFetcher<CommitteeBasicInfoModel>(
    buildEndpoint(AgendaEndpoints.committees.controllerActionString("basicInfo"), id),
    new CommitteeBasicInfoModel(),
    defaultDataTransform,
    CommitteeBasicInfoModel
  );

  return (    
    <CommitteeProvider providedCommitteeId={id}>
      <AsyncLoadingSection loadingStatus={loadingStatus}>
        <Render condition={!data?.allowPublicApplications}>
          <AdminSubHeaderMainLayout
            subRoute={Routes.CommitteesView}
            title={data.name as string}
          />
        </Render>
        <Render condition={data?.allowPublicApplications}>
          <AdminSubHeaderMainLayout
            subRoute={Routes.OpenCommitteesView}
            title={data.name as string}
          />
        </Render>
      </AsyncLoadingSection>
    </CommitteeProvider>
  );
};
